export const legalEndpoints = {
  documents: '/legal/documents',
  termsAcceptance: '/legal/terms-acceptance',
  candidateNotices: '/legal/candidate-notices',
  jobAiDisclosure: '/legal/jobs/{jobId}/ai-disclosure',
} as const;
